export enum WeekDay {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export type AssignedPaymentFrequency =
  | { type: 'daily' }
  | { type: 'weekly'; dayOfWeek: WeekDay }
  | { type: 'monthly'; dayOfMonth: number }
  | { type: 'yearly'; dayOfYear: number }

export type AnchorablePayment = {
  type: 'anchorable'
  period: 'weekly' | 'monthly' | 'yearly'
}

export type FixedPayment =
  | { type: 'fixed'; frequency: 'daily' }
  | { type: 'fixed'; frequency: 'weekly'; dayOfWeek: WeekDay }
  | { type: 'fixed'; frequency: 'monthly'; dayOfMonth: number }
  | { type: 'fixed'; frequency: 'yearly'; dayOfYear: number }

export type PaymentFrequencyRequest = AnchorablePayment | FixedPayment
export interface CreatePriceRequest {
  billableId: string
  type: string
  paymentFrequency: PaymentFrequencyRequest
}

export interface Billable {
  id: string
  name: string
  unit: string
}

export enum BillablePriceType {
  LINEAR = 'Linear',
}

export const isUnsupportedBillablePrice = (price: unknown): price is UnsupportedBillablePrice => {
  return (price as UnsupportedBillablePrice)?.supported === false
}

export interface UnsupportedBillablePrice {
  billableId: string
  supported: false
}

export interface BillablePrice {
  supported: true
  billableId: string
  type: string
  paymentFrequency: PaymentFrequencyRequest
}
